<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-1 mt-3">
        <v-row>
          <v-col cols="8">
            <v-card elevation="0" class="detail-card" height="10vh">
              <v-card-text>
                <v-row>
                  <v-col cols="2" class="covered-position3">
                    <span class="current-mission-header-content">فیلتر</span>
                  </v-col>
                </v-row>
                <v-row class="mt-n5">
                  <v-col cols="11">
                    <v-row>
                      <v-col cols="4">
                        <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense
                          clearable autocomplete="off" @click:clear="clearDateTime('searchFromDate')"
                          clear-icon="mdi-close-circle-outline" v-model="tempSearchFromDate"
                          @focus="showSearchFromDate = true" @click="showSearchFromDate = true" label="از تاریخ"
                          prepend-inner-icon="mdi-calendar-range mdi-18px">
                          <template slot="append">
                            <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime"
                          @open="onOpen" @change="dateTimeChange('searchFromDate')" :editable="true"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#moveFromStationTime-moveFromStationTime" @close="showSearchFromDate = false" />
                      </v-col>
                      <v-col cols="4">
                        <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime"
                          dense autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                          clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate"
                          @focus="showSearchToDate = true" @click="showSearchToDate = true" label="تا تاریخ"
                          prepend-inner-icon="mdi-calendar-range mdi-18px">
                          <template slot="append">
                            <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen"
                          v-model="searchToDate" @change="dateTimeChange('searchToDate')" :editable="true"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#arriveToLocationTime-arriveToLocationTime" @close="showSearchToDate = false" />
                      </v-col>
                      <v-col cols="4">
                        <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                          clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهر"
                          v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                          style="font-size: 11px !important"></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" class="mr-n3">
                    <v-btn color="darkColor" dark elevation="0" @click="search()">جستجو</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card elevation="0" class="detail-card" height="10vh">
              <v-card-text>
                <v-row>
                  <v-col cols="4" class="covered-position3">
                    <span class="current-mission-header-content">گزارشات</span>
                  </v-col>
                </v-row>
                <v-col cols="12" class="mt-n4">
                  <v-row>
                    <v-col cols="2" class="mr-n3">
                      <v-btn small color="darkColor" dark @click="goToDailyReportByGeographicalTypeWithCode()">
                        گزارش کد ها
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="4">
                      <v-btn small color="darkColor" dark @click="goToDailyReportByGeographicalType()">
                        آمار روزانه شهری-جاده ای
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="4">
                      <v-btn small color="darkColor" dark @click="goToDailyReportByZone()">
                        آمار روزانه بر اساس ناحیه
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-3 mr-1">
        <v-card elevation="0" class="detail-card relative" height="35vh">
          <v-card-text>
            <v-row>
              <v-col cols="4" class="covered-position3">
                <span class="current-mission-header-content">
                  ماموریت ها بر اساس نتایج به تفکیک ناحیه
                </span>
              </v-col>
              <v-btn @click="
                exportToExcel(
                  missionsInformationTableHeaders,
                  missionsDailyReportItmes,
                  'text',
                  'amar_mission_information',
                )
                " fab dark small dense color="darkColor" elevation="0" class="export_excel_btn">
                <v-icon dark>mdi-file-excel mdi-18px</v-icon>
              </v-btn>
            </v-row>
            <v-row>
              <v-col cols="12" class="mt-n6">
                <template>
                  <v-data-table hide-default-header fixed-header multi-sort hide-default-footer
                    :headers="missionsInformationTableHeaders" :items="missionsDailyReportItmes"
                    :items-per-page="missionsDailyReportItmes.length" height="33vh" class="elevation-0 tt">
                    <template v-slot:header="props">
                      <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                        @group="props.on.group" />
                    </template>
                    <template v-slot:no-data>
                      <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                    </template>
                  </v-data-table>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-3 mr-1">
        <v-row>
          <v-col cols="6">
            <v-card elevation="0" class="detail-card relative" height="42vh">
              <v-card-text>
                <v-row>
                  <v-col cols="4" class="covered-position3">
                    <span class="current-mission-header-content">نتایج بر اساس تشخیص</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-btn @click="
                    exportToExcel(
                      resultsInformationTableHeaders,
                      resultsDailyReportItmes,
                      'text',
                      'amar_result_information',
                    )
                    " fab dark small dense color="darkColor" elevation="0" class="export_excel_btn">
                    <v-icon dark>mdi-file-excel mdi-18px</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col cols="12" class="mt-n6">
                    <template>
                      <v-data-table hide-default-header fixed-header multi-sort hide-default-footer height="30vh"
                        class="elevation-0 tt" :headers="resultsInformationTableHeaders"
                        :items="resultsDailyReportItmes" :items-per-page="resultsDailyReportItmes.length">
                        <template v-slot:header="props">
                          <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                            @group="props.on.group" />
                        </template>
                        <template v-slot:no-data>
                          <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card elevation="0" class="detail-card relative" height="42vh">
              <v-card-text>
                <v-row>
                  <v-col cols="8" class="covered-position3">
                    <span class="current-mission-header-content">
                      تماس های اداره ارتباطات، هماهنگی و پایش عملیات
                    </span>
                  </v-col>
                  <v-btn @click="
                    exportToExcel(
                      callsInformationTableHeaders,
                      callsDailyReportItmes,
                      'text',
                      'amar_calls_information',
                    )
                    " fab dark small dense color="darkColor" elevation="0" class="export_excel_btn">
                    <v-icon dark>mdi-file-excel mdi-18px</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col cols="12" class="mt-n6">
                    <template>
                      <v-data-table hide-default-header fixed-header multi-sort hide-default-footer height="30vh"
                        class="elevation-0 tt" :headers="callsInformationTableHeaders" :items="callsDailyReportItmes"
                        :items-per-page="callsDailyReportItmes.length">
                        <template v-slot:header="props">
                          <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                            @group="props.on.group" />
                        </template>
                        <template v-slot:no-data>
                          <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DailyReportAmarHelper from '@/Helpers/Report/Amar/DailyReportAmarHelper.js';
import ExcelHelper from '../../../Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import CityMixin from '@/Mixins/BaseInformation/CityMixin.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

export default {
  name: 'AmarDailyReport',
  title: 'آمار روزانه',
  inject: ['load'],
  mixins: [
    DailyReportAmarHelper,
    snackBar,
    ShearedMixin,
    ShearedHelper,
    CityMixin,
    ReportMixin,
    ExcelHelper,
  ],
  components: {
    AppGroupTableHeader,
  },
  created() {
    this.$root.$refs.AmarDailyReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      this.getListOfCitysForOther();
      this.getMissionPhoneWithResultByZoneForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
      this.getPatientCountByDiagnosisForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
      this.getInboundCallsForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.export_excel_btn {
  position: absolute;
  left: 1rem;
  top: -1rem;
  z-index: 11;
}

.detail-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 15px !important;
}

.current-mission-header-content {
  font-size: 13px;
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.covered-position3 {
  margin-top: -3.5vh !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}

>>>th {
  position: sticky !important;
  top: 0 !important;
}
</style>
